import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import authReducers from "./authReducers";
import allOverlayScreenReducers from "./overlayScreenReducers/allOverlayScreenReducers";
import onboardingReducers from "./onBoardingReducers/onboardingReducers";
import AddItemCatelogeReducers from "./AddItemGlobalCatelogReducers/AddItemGlobalCateloge";
import categoryReducers from "./onBoardingReducers/categoryReducers";
import storageReducer from "./dataStorage/storageReducer";
import notificationReducer from "./notificationReducer/notificationReducer";
import categoriesReducer from "./categoryReducer/categoriesReducer";
import offersEventsReducer from "./offerAndEventReducers/offerAndEventReducers";
import rsvpEventReducer from "./offerAndEventReducers/rsvpEventReducers";
import allDinerDetailsReducer from "./dashboardReducers/getAllDinerReducers";
import allVendorRatingReview from "./dashboardReducers/getAllRatingReviewReducers";
import allVendorUsersTickets from "./vendorTicketsReducers/vendorUsersTicketsReducers";
import allVendorIssuesSuggestion from "./vendorIssuesSuggestionReducers/vendorIssuesSuggestionReducers";
import userManagement from "./superAdminReducers/usersManagement";
import adminAllVendorsInfo from "./superAdminReducers/adminAllVendorsReducers";
import superAdminOffers from "./superAdminReducers/superAdminOffers";
import commonSuperAdmin from "./superAdminReducers/commonSuperAdmin";
import vendorOrderingReducers from "./OrderingReducers/vendorOrderingReducers";
import superAdminOrderingReducers from "./OrderingReducers/superAdminOrderingReducers";
import vendorReportsRestaurant from "./reportReducer/reports";
import superAdminReferrals from "./superAdminReducers/superAdminReferrals";
import vendorreferralsReducer from "./vendorreferralsReducer/vendorreferralsReducer";
import vendorRoleManagementReducer from "./roleManagementReducer/vendorRoleManagementReducer";
import superAdminRoles from "./superAdminReducers/superAdminRoles";
import superadminManageTransactions from "./superAdminReducers/superAdminManageTransactions";
import distanceReducer from "./distanceReducer";
import chatReducer from "./chatReducer/chatReducer";
import adminHelpFaq from "../reducers/superAdminReducers/superAdminHelpFAQreducers";
import superAdminOnboardingReducers from "../reducers/superAdminReducers/superAdminVendorOnboarding";
import superAdminTemplatesReducers from "../reducers/superAdminReducers/superAdminTemplatesReducers";
import superAdminVendorSummaryReports from "../reducers/superAdminReducers/superAdminActivitySummaryReports";
import adminChainManagementReducer from "./superAdminReducers/adminChainManagementReducer";
import superAdminOrderActivityDashboard from "./superAdminReducers/adminOrderActivityDashboard";
import reports from "./reportReducer/reports";
import vendorEarningsDashboard from "./VendorEarnings/vendorEarningsReducers";
import superAdminWallet from "./superAdminReducers/superAdminWalletReducers";
import vendorAccess from "./vendorAccessReducer";
import popupList from "./popupReducer";
import adminPopupList from "./adminPopupReducer";
import promoVideo from "./superAdminReducers/superAdminPromoVideos";
import superAdminUOMService from "./superAdminReducers/superAdminUOMService";
import superAdminMaintainPromotion from "./superAdminReducers/superAdminMaintainPromotionTags";
import superAdminOnlineAndOfflineReducers from "./superAdminReducers/superAdminOnlineAndOfflineReducers";
import superAdminExperience from "./Experience/adminExperience";
import superAdminShortVideos from "./ShortVideos/adminShortVideos"

/************************* @DESC SUPER ADMIN WHOLE VIES REDUCERS *************************/
import adminWholeVendorOnboardingReducers from "./SuperAdminVendorDashboardReducers/SuperAdminVendorOnboardDetails";
import superAdminWholeSeatingReducers from "./SuperAdminVendorDashboardReducers/SuperAdminSeatingReducers";
import DeliveryPersonReducers from "./DeliveryPersonReducers/DeliveryPersonReducers";

export default combineReducers({
  errors: errorReducer,
  auth: authReducers,
  overlayScreens: allOverlayScreenReducers,
  onboarding: onboardingReducers,
  merchantItemCateloge: AddItemCatelogeReducers,
  category: categoryReducers,
  storage: storageReducer,
  notifications: notificationReducer,
  categories: categoriesReducer,
  offersevents: offersEventsReducer,
  rsvpEvent: rsvpEventReducer,
  allDinerDetails: allDinerDetailsReducer,
  vendorRatingReviews: allVendorRatingReview,
  vendorUsersTickets: allVendorUsersTickets,
  vendorIssuesSuggestion: allVendorIssuesSuggestion,
  userManagement: userManagement,
  adminAllVendorsInfo: adminAllVendorsInfo,
  superAdminOffers: superAdminOffers,
  commonSuperAdmin: commonSuperAdmin,
  vendorOrdering: vendorOrderingReducers,
  superAdminOrdering: superAdminOrderingReducers,
  vendorReportsRestaurant: vendorReportsRestaurant,
  superAdminReferrals: superAdminReferrals,
  vendorreferrals: vendorreferralsReducer,
  vendorRoleManagement: vendorRoleManagementReducer,
  superAdminRoles: superAdminRoles,
  superadminManageTransactions: superadminManageTransactions,
  distance: distanceReducer,
  chatData: chatReducer,
  superAdminHelpFaq: adminHelpFaq,
  superAdminOnboarding: superAdminOnboardingReducers,
  superAdminTemplates: superAdminTemplatesReducers,
  superAdminVendorSummaryReports: superAdminVendorSummaryReports,
  superAdminChainVendors: adminChainManagementReducer,
  superAdminOrderActivity: superAdminOrderActivityDashboard,
  reports: reports,
  vendorEarnings: vendorEarningsDashboard,
  superAdminWallet: superAdminWallet,
  vendorAccess: vendorAccess,
  popupList: popupList,
  adminPopupList: adminPopupList,
  promoVideo: promoVideo,
  uomRatioManagement: superAdminUOMService,
  maintainPromotion: superAdminMaintainPromotion,
  superAdminOfflineOnlineOffers: superAdminOnlineAndOfflineReducers,
  superAdminExperience: superAdminExperience,
  superAdminShortVideos: superAdminShortVideos,

  /************************************************
   * @DESC SUPER ADMIN ACCESS VENDOR DASHBOARD START
   ***********************************************/
  adminWholeVendorOnboarding: adminWholeVendorOnboardingReducers,
  adminWholeSeating: superAdminWholeSeatingReducers,
  /************************************************
   * @DESC SUPER ADMIN ACCESS VENDOR DASHBOARD END
   ***********************************************/
  deliveryPersonData: DeliveryPersonReducers
});
